import type { LandingPageContent } from '../types'

export const INSTALACION_ELECTRICA_FOTOVOLTAICA: LandingPageContent = {
  slug: 'instalacion-electrica-fotovoltaica',
  lang: 'es',
  topicId: 'photovoltaik-elektroinstallation',
  title: 'Instalación eléctrica fotovoltaica – conexión profesional',
  metaDescription:
    '¿Paneles montados pero falta la conexión eléctrica? Solicite solo la instalación eléctrica: ' +
    'inversor, batería, cambio de contador y alta eléctrica.',
  keywords: [
    'instalación eléctrica fotovoltaica',
    'conectar instalación fotovoltaica',
    'instalar inversor fotovoltaico',
    'dar de alta placas solares compañía eléctrica',
    'electricista para instalación fotovoltaica',
  ],
  eyebrow: 'Solo la conexión eléctrica',
  h1: 'Conectar su instalación fotovoltaica de forma profesional',
  intro:
    '¿Los paneles ya están montados pero falta la conexión eléctrica? Para la parte eléctrica es ' +
    'obligatorio en Alemania un electricista cualificado - entre otras cosas, para el alta en la ' +
    'compañía eléctrica. En Roofora puede solicitar este servicio como tipo de solicitud propio, sin ' +
    'necesidad de un sistema completo.',
  sections: [
    { type: 'heading', text: 'Para quién merece la pena una solicitud de solo instalación eléctrica' },
    {
      type: 'list',
      items: [
        'Los paneles ya están montados (por ejemplo, por usted mismo o por otra empresa) y solo falta la conexión eléctrica',
        'Quiere añadir una batería o un inversor',
        'Falta el cambio de contador o el alta en la compañía eléctrica',
      ],
    },
    { type: 'heading', text: 'Qué puede incluir la instalación eléctrica' },
    {
      type: 'list',
      items: [
        'Conexión y puesta en marcha del inversor',
        'Instalación posterior de una batería del tamaño deseado',
        'Adaptación o cambio del cuadro eléctrico',
        'Alta y puesta en marcha ante su compañía eléctrica',
      ],
    },
    { type: 'heading', text: 'Así funciona una solicitud de instalación eléctrica' },
    {
      type: 'paragraph',
      text:
        'Usted indica qué equipo ya está instalado, si necesita batería o inversor y si hace falta un ' +
        'cambio de contador. Las empresas instaladoras con cualificación de electricista ven su ' +
        'solicitud anónima y presentan presupuestos sin compromiso solo para la instalación.',
    },
    { type: 'heading', text: 'Contacto solo después de su autorización' },
    {
      type: 'paragraph',
      text:
        'Como en cualquier tipo de solicitud en Roofora, el contacto solo se produce cuando usted ' +
        'autoriza individualmente a una empresa concreta - sin autorización colectiva, sin lluvia de ' +
        'llamadas.',
    },
  ],
  faq: [
    {
      q: '¿La instalación eléctrica tiene que hacerla obligatoriamente una empresa especializada?',
      a: 'Sí - la conexión eléctrica y el alta en la compañía eléctrica deben ser realizadas en Alemania por una empresa de electricidad registrada.',
    },
    {
      q: '¿Puedo solicitar solo la instalación de una batería, sin otros trabajos?',
      a: 'Sí - indique en la solicitud simplemente el tamaño de batería deseado; el resto de datos sobre el equipo existente son opcionales.',
    },
    {
      q: 'Solo necesito un inversor nuevo, sin otros trabajos - ¿es posible?',
      a: 'Sí - "¿Ya hay equipo instalado (inversor/batería)?" es un campo opcional en la solicitud. Indique simplemente que necesita un inversor; el resto de datos sobre la instalación existente puede dejarlos en blanco.',
    },
  ],
  primaryCta: { label: 'Solicitar instalación eléctrica', action: 'customer' },
  secondaryCta: { label: '¿Solo necesita el montaje en el tejado?', action: 'link', href: '/montaje-paneles-solares' },
  relatedLinks: [
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Planificar la instalación paso a paso', href: '/planificar-instalacion-fotovoltaica' },
    { label: 'Wallbox y coche eléctrico con excedente solar', href: '/fotovoltaica-wallbox-coche-electrico' },
  ],
}
